// Navbar.tsx
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';  
import './Navbar.css';
import Sidebar from '../sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import Clock from '../ui/Clock';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/userSlice';
import { Auth } from 'aws-amplify';
import Language from './Language';
import UserMenu from './UserMenu';

const Navbar: React.FC = () => {
  // サイドバーが開いているかどうかの状態を管理する
  const [isOpen, setIsOpen] = useState(false)
  // サイドバーの状態を変更する関数
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();

  const menuRef = useRef<HTMLDivElement>(null);
  const userId = useSelector((state: RootState) => state.user.userInfo?.user_id ?? "");

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      dispatch(logout());
      setIsMenuOpen(false);
      await Auth.signOut();
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  };

  return (
    <header className="header">
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="nav-main-container navbar">
        <div className="navbtn-item">
          <button className="navbtn" onClick={toggleSidebar}>
            <div>
              <FontAwesomeIcon icon={faBars} />
              <span className="sr-only">MENU</span>
            </div>
          </button>
        </div>
        <div className="center-item">
          <div className="center-container">
            <div className="site">
              <Link to="/">
                <img src="images/app-logo.png" width="56" height="56" alt="logo" />
              </Link>
            </div>
            <h1 className="title">
              <Link to="/" className="nav-title">
                <span className="full-text">Process Flow Manager</span>
                <span className="short-text">PFM</span>
              </Link>
            </h1>
          </div>
        </div>
        <div className="clock-item">
        <Clock />
        </div>
        <div className="language-item">
        <Language />
        </div>
        <div className="team-item">
          <div className="team-icon" onClick={() => setIsMenuOpen(!isMenuOpen)} ref={menuRef}>
            <img className="user-menu-icon" 
              src={
                userId.endsWith("@ngci.co.jp") ? "images/operator.svg" : "images/team.svg" 
              }
              width="40" height="40" alt="team" />
            {isMenuOpen && (
              <div className='user-menu-item'>
                <UserMenu
                  handleLogout={handleLogout}
                ></UserMenu>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
